class VideoBackgroundGroup {
    constructor(selector, videoBackgroundSelector, videoBackgroundFactoryInstance) {
        this.element = selector;
        this.anyPlay = false;
        this.swiper = document.querySelector('.sw-video-reviews-slider').swiper;

        this.swiper.on('init', this.setDescription.bind(this));
        this.swiper.on('slideChange', this.pauseAll.bind(this));
        this.swiper.on('slideChange', this.setDescription.bind(this));
        this.swiper.init();
        new VideoBackgrounds('[data-vbg]');

        if (typeof this.element === 'string') this.element = document.querySelector(selector);
        if (!this.element) return;
        this.elements = this.element.querySelectorAll(videoBackgroundSelector || '[data-vbg]');
        if (!this.elements.length) return;

        this.videoBackgroundFactoryInstance = videoBackgroundFactoryInstance;
        this.stack = [];
        this.map = new Map();

        for (let i = 0; i < this.elements.length; i++) {
            const element = this.elements[i];
            if (!element.hasAttribute('data-vbg-uid') && this.videoBackgroundFactoryInstance) this.videoBackgroundFactoryInstance.add(element);
            this.stack.push(element);
            this.map.set(element, i);

            if (i === 0) {
                this.current = 0;
                this.currentElement = element;
                if (this.videoBackgroundFactoryInstance) this.currentInstance = this.videoBackgroundFactoryInstance.get(element);
            }

            element.dataset.index = i;
            element.dataset.seek = 0;

            const container = this.getContainer(element);
            const groupPlay = container.querySelector('[data-play]');
            const groupPause = container.querySelector('[data-pause]');
            const groupMute = container.querySelector('[data-mute]');
            const groupUnmute = container.querySelector('[data-unmute]');

            groupPlay.addEventListener('click', this.play.bind(this));
            groupPause.addEventListener('click', this.pause.bind(this));
            groupMute.addEventListener('click', this.mute.bind(this));
            groupUnmute.addEventListener('click', this.unmute.bind(this));

            element.addEventListener('video-background-ended', this.onVideoEnded.bind(this));
            element.addEventListener('video-background-seeked', this.onVideoSeeked.bind(this));
            element.addEventListener('video-background-pause', this.onVideoPause.bind(this));
            element.addEventListener('video-background-ready', this.onVideoReady.bind(this));
            element.addEventListener('video-background-ready', this.onChange.bind(this));
            element.addEventListener('video-background-state-change', this.setVideoBackgroundFactoryInstance.bind(this));
            element.addEventListener('video-background-state-change', this.onChange.bind(this));
            element.addEventListener('video-background-time-update', this.setVideoBackgroundFactoryInstance.bind(this));
        }
    }

    setVideoBackgroundFactoryInstance(event) {
        if (this.videoBackgroundFactoryInstance) return;
        this.videoBackgroundFactoryInstance = event.detail.factoryInstance;
        if (!this.currentInstance) this.currentInstance = this.videoBackgroundFactoryInstance.get(this.currentElement);
    }

    onChange(event) {
        if (event.detail.currentState === 'notstarted') {
            const container = this.getContainer(event.target);

            container.classList.remove('play');
            container.classList.remove('unmute');
            container.classList.add('mute');
        }

        if (event.detail.currentState === 'paused') {
            const container = this.getContainer(event.target);
            container.classList.remove('play');
        }

        if (event.detail.currentState === 'playing') {
            const container = this.getContainer(event.target);
            container.classList.add('play');
        }
    }

    onVideoReady(event) {
        if (this.stack[this.current] !== event.detail.element) return;
        this.setVideoBackgroundFactoryInstance(event);
        //if (event.detail.currentState !== 'playing') event.detail.play();
    }

    onVideoPause(event) {
        this.setVideoBackgroundFactoryInstance(event);
        const stackIndex = this.map.get(event.detail.element);

        const container = this.getContainer(event.target);
        container.classList.remove('play');

        event.detail.element.dataset.seek = event.detail.currentTime;

        if (stackIndex === this.current) return;
    }

    levelSeekBars() {
        for (let i = 0; i < this.stack.length; i++) {
            if (i === this.current) continue;
            const seekBarElem = this.getSeekBar(this.videoBackgroundFactoryInstance.get(this.stack[i]));
            if (!seekBarElem) continue;
            if (i < this.current) {
                this.setProgress(seekBarElem, 100);
            } else {
                this.setProgress(seekBarElem, 0);
            }
        }
    }

    getSeekBar(currentInstance) {
        if (!currentInstance) return;
        const uid = currentInstance.uid;
        const element = document.querySelector(`.js-seek-bar-wrap[data-target-uid="${uid}"]`);
        if (!element) return;
        return element;
    }

    setProgress(seekBarElem, value) {
        if (!seekBarElem) return;
        const progressElem = seekBarElem.querySelector('.js-seek-bar-progress');
        const inputElem = seekBarElem.querySelector('.js-seek-bar');
        if (progressElem) progressElem.value = value;
        if (inputElem) inputElem.value = value;
    }

    onVideoSeeked(event) {
        const current = this.map.get(event.detail.element);
        if (this.current !== current) this.setCurrent(current, true);
    }

    setCurrent(index, seek) {
        const previous = this.current;
        if (index >= this.stack.length) index = 0;
        if (index < 0) index = this.stack.length - 1;
        const previousInstance = this.videoBackgroundFactoryInstance.get(this.stack[previous]);
        this.current = index;
        this.currentInstance = this.videoBackgroundFactoryInstance.get(this.stack[this.current]);
        this.currentElement = this.stack[this.current];

        this.stack[previous].style.display = 'none';
        this.currentElement.style.display = 'block';

        if (!seek) {
            const seekBarElem = this.getSeekBar(this.currentInstance);
            if (seekBarElem) this.setProgress(seekBarElem, 0);
            this.currentInstance.seek(0);
        }

        setTimeout(() => {
            if (this.currentInstance.currentState !== 'playing') this.currentInstance.play();
        }, 100);

        //&& previousInstance.currentState !== 'paused'
        if (previousInstance) {
            previousInstance.pause();
        }

        setTimeout(this.levelSeekBars.bind(this), 100);

        if (index >= this.stack.length) this.dispatchEvent('video-background-group-forward-rewind');
        if (index < 0) this.dispatchEvent('video-background-group-backward-rewind');
    }

    dispatchEvent(name) {
        this.element.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: this }));
    }

    onVideoEnded(event) {
        if (event.detail.element !== this.currentElement) return;
        this.next();
    }

    next() {
        this.setCurrent(this.current + 1);
        this.dispatchEvent('video-background-group-next');
    }

    prev() {
        this.setCurrent(this.current - 1);
        this.dispatchEvent('video-background-group-previous');
    }

    unmute(event) {
        const container = this.getContainer(event.target);
        const index = this.getIndex(container);
        const instance = this.videoBackgroundFactoryInstance.get(this.stack[index]);
        if (!instance) return;

        instance.unmute();

        container.classList.remove('mute');
        container.classList.add('unmute');

        this.dispatchEvent('video-background-group-umnute');
    }

    mute(event) {
        const container = this.getContainer(event.target);
        const index = this.getIndex(container);
        const instance = this.videoBackgroundFactoryInstance.get(this.stack[index]);
        if (!instance) return;

        instance.mute();

        container.classList.remove('unmute');
        container.classList.add('mute');

        this.dispatchEvent('video-background-group-mute');
    }

    pause(event) {
        const container = this.getContainer(event.target);
        container.classList.remove('play');

        this.currentInstance.pause();
        this.dispatchEvent('video-background-group-previous');
    }

    pauseAll() {
        if (this.anyPlay) {
            for (let i = 0; i < this.stack.length; i++) {
                const instance = this.videoBackgroundFactoryInstance.get(this.stack[i]);
                if (!instance) return;
                const container = this.getContainer(this.stack[i]);
                container.classList.remove('play');

                instance.pause();
            }
            this.dispatchEvent('video-background-group-previous');
        }
    }

    play(event) {
        const container = this.getContainer(event.target);
        const index = this.getIndex(container);
        const seek = this.getSeek(container);

        this.pauseAll();

        container.classList.add('play');
        this.setCurrent(index, seek);

        this.anyPlay = true;

        if (typeof this.currentInstance.player.isMuted !== 'undefined' && this.currentInstance.player.isMuted()) {
            container.classList.remove('unmute');
            container.classList.add('mute');
        }

        if (typeof this.currentInstance.player.seekTo !== 'undefined') {
            this.currentInstance.player.seekTo(seek);
        }

        this.currentInstance.play();

        this.dispatchEvent('video-background-group-previous');
    }

    getContainer(element) {
        return element.closest('[data-video-review]');
    }

    getIndex(container) {
        return container.querySelector('[data-index]').dataset.index * 1;
    }

    getSeek(container) {
        return container.querySelector('[data-seek]').dataset.seek * 1;
    }

    setDescription(event) {
        event.slides.forEach((element) => {
            if (element.className.includes('swiper-slide-active')) {
                const parent = element.closest('.sw-video-reviews-container');
                const index = event.realIndex;
                const descriptions = parent.querySelectorAll('[data-sw-review-description]') ?? [];

                for (let i = 0; i < descriptions.length; i++) {
                    descriptions[i].classList.remove('show');
                }

                const description = parent.querySelector('[data-sw-review-description-index="'+index+'"]') ?? '';

                if (!description) {
                    return
                }

                description.classList.add('show');
            }
        })
    }
}

function init() {
    /*
    const groups = document.querySelectorAll('.sw-video-reviews');
    for (let i = 0; i < groups.length; i++) {
        const group = groups[i];
        const elements = group.querySelectorAll('[data-vbg]');

        for (let j = 0; j < elements.length; j++) {
            elements[j].addEventListener('video-background-state-change', function(event) {
                const id = event.target.getAttribute('data-vbg-uid');
                console.log(id, event.detail.type, event.detail.currentState);
                console.log(event.detail);
            });

            elements[j].addEventListener('video-background-ready', function(event) {
                const id = event.target.getAttribute('data-vbg-uid');
                console.log('ready', id, event.detail.type, event.detail.currentState);
            });
        }
    }

    */


    const videoGroup = new VideoBackgroundGroup('.sw-video-reviews-slider-wrapper');
}

function mutedAll() {
    const elements = document.querySelectorAll('.sw-video-reviews-slider video');
    elements.forEach((video) => {
        video.muted = "muted";
    });
}

window.addEventListener('DOMContentLoaded', () => {
    init();
    setTimeout(() => {
        mutedAll();
    }, 100);
});